import React, { useEffect } from 'react'
import { DeleteFilled, EyeOutlined, FilterOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Card, Col, DatePicker, Input, Modal, Row, Space, Table } from 'antd'
import { useSelector } from 'react-redux';
import { hideLoading, showLoading, useLoadingDispatch } from '../../context/loadingContext';
import AuthService from '../../Components/auth/AuthService';
import { useNavigate } from 'react-router-dom';
import { Pagination } from '@mui/material';
import { netsuite_url } from '../../Components/config';
import { showMessage } from '../../Components/Utils/message';
import dayjs from 'dayjs';
import { encodeId } from '../../Components/common/CommonFun';
import { DATE_FORMAT, DEFAULT_DATE_FORMAT, EXPIRATION_TIME } from '../../Components/common/Constants';
import { styled } from '@mui/system';
const DataSheet = styled('div')`
   .ant-card-body {
      padding: 10px;
    };
    .ant-card-head {
      min-height: 40px;
    };
`;
const Auth = new AuthService();
const TransactionsCreditNoteList = () => {
  const { aisles, locations, products, roles } = useSelector((state) => state?.AppState?.userCreds);
  const navigate = useNavigate();
  const layoutDispatch = useLoadingDispatch()
  const [pageChange, setPageChange] = React.useState(false);
  const [limit] = React.useState(50);
  const [totalPages, setTotalPages] = React.useState(0);
  const [totalCount, setTotalCount] = React.useState(null);
  const [data, setData] = React.useState([]);

  const { RangePicker } = DatePicker;

  const [filters, setFilters] = React.useState(() => {
    const existing = localStorage.getItem('TransactionCNFilters');
    const parsed = existing ? JSON.parse(existing) : {};
    const currentTime = new Date().getTime();

    const defaultFilters = {
      dateRange: [dayjs().startOf("month"), dayjs().endOf("month")],
      batchCode: '',
      page: 1,
    };

    if (parsed.timestamp && currentTime - parsed.timestamp < EXPIRATION_TIME) {
      if (parsed.dateRange) {
        parsed.dateRange = [
          parsed.dateRange[0] ? dayjs(parsed.dateRange[0]) : defaultFilters.dateRange[0],
          parsed.dateRange[1] ? dayjs(parsed.dateRange[1]) : defaultFilters.dateRange[1]
        ];
      }
      return { ...defaultFilters, ...parsed };
    }
    localStorage.removeItem('TransactionCNFilters');
    return defaultFilters;
  });

  const updateFilters = (newValues) => {
    const existingString = localStorage.getItem('TransactionCNFilters');
    const existing = existingString ? JSON.parse(existingString) : {};

    Object.assign(existing, newValues);
    existing.timestamp = new Date().getTime();

    localStorage.setItem('TransactionCNFilters', JSON.stringify(existing));
  };
  const dataCol = [

    {
      title: 'Document Number',
      render: (text, record) => {
        const hasRole5 = roles?.some(r => r.role_id === 5);

        return (
          <>
            {
              hasRole5 ? (
                <>{record.credit_note_number}</>
              ) : (
                <span>
                  <a
                    href={`${netsuite_url}/app/accounting/transactions/custcred.nl?id=${record.internal_id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {record.credit_note_number}
                  </a>
                </span>
              )

            }

          </>

        );
      },
    },
    {
      title: 'Customer',
      render: (record) => {
        return <span>{record?.customer_code ? `${record?.customer_code} - ${record?.customer_name}` : ''}</span>
      }
    },
    {
      title: 'Posting Date',
      render: (record) => {
        return <span>{record?.posting_date ? dayjs(record?.posting_date).format('DD-MM-YYYY') : ''}</span>
      }
    },


    {
      title: 'Action',
      key: 'action',
      align: 'right',
      render: (text, record) => (
        <div>

          <EyeOutlined
            style={{
              fontSize: "25px",
              cursor: "pointer",
              marginRight: "5px",
              color: "#006cb8",
            }} onClick={() => {
              const hasedID = encodeId(record?.id)

              navigate(`/transaction-cn/${hasedID}`)
            }} />
{
            !record?.posted_by > 0 && (
              <DeleteFilled style={
                {
                  fontSize: "25px",
                  cursor: "pointer",
                  color: "#ff0000",
                }} onClick={() => {
                  Modal.confirm({
                    title: 'Delete Transaction',
                    centered: true,
                    content: `Are you sure you want to delete this transaction?`,
                    onOk: () => deleteTransaction(record.id),
                    okText: 'Delete',
                    cancelText: 'Cancel',
                    width: 600,
                    okButtonProps: { size: "large" },
                    cancelButtonProps: { size: "large" },
                  });
                }}
              />
            )
          }
        </div>
      )
    },

  ];

  const deleteTransaction = async (id) => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/stock/credit-notes`, {
        method: "DELETE",
        body: JSON.stringify({ id: id })

      });
      if (res?.ack) {
        showMessage('success', res?.message);
        getTransactionData();
      } else {
        showMessage('error', res?.message);
      hideLoading(layoutDispatch);

      }
    } catch (err) {
      console.log(err);
      showMessage('error', err?.message);
      hideLoading(layoutDispatch);
    } 
    // finally {
    //   hideLoading(layoutDispatch);
    // }
  };

  const getTransactionData = async () => {
    showLoading(layoutDispatch);
    const dataToSend = {
      limit: limit,
      page: filters.page,
    }
    if (filters?.dateRange && filters?.dateRange[0] && filters?.dateRange[1]) {
      dataToSend.start_date = dayjs(filters?.dateRange[0]).format(DEFAULT_DATE_FORMAT);
      dataToSend.end_date = dayjs(filters?.dateRange[1]).format(DEFAULT_DATE_FORMAT);
    }
    if (filters?.batchCode) {
      dataToSend.searchText = (filters?.batchCode || '').trim();
    }
    try {
      const res = await Auth.post(`/stock/credit-notes`, dataToSend)
      if (res.ack) {
        setData(res?.credit_notes);
        setTotalPages(Math.ceil(res.total_count / limit));
        setTotalCount(res.total_count);
      } else {
        showMessage('error', res.message);
      }
    } catch (err) {
      console.log(err);
    } finally {
      hideLoading(layoutDispatch);
    }
  }

  useEffect(() => {
    const timeOutId = setTimeout(() => getTransactionData(), 100);
    return () => clearTimeout(timeOutId);
  }, [filters.page, filters.dateRange]);

  const handleChange = (event, value) => {
    setFilters(prev => ({ ...prev, page: value }));
    updateFilters({ page: value });
    setPageChange(true)
  };

  return (
    <DataSheet>
      <Card title={<><FilterOutlined style={{ color: '#6cb8ff'}}/> Credit Notes</>} style={{ marginBottom: '10px' }}>
        <Row gutter={[6, 1]}>
          <Col xs={24} md={12} lg={8}>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '4px' }}>Date Range</label>
            <RangePicker
              style={{ width: '100%' }}
              value={filters.dateRange}
              onChange={(dates) => {
                setFilters(prev => ({ ...prev, dateRange: dates, page: 1 }));
                updateFilters({ 
                  dateRange: dates ? [dates[0] ? dates[0].format(DEFAULT_DATE_FORMAT) : null, dates[1] ? dates[1].format(DEFAULT_DATE_FORMAT) : null] : null,
                  page: 1 
                });
              }}
              format={DATE_FORMAT}
              allowClear={false}
            />
          </Col>
          <Col xs={24} md={12} lg={6}>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '4px' }}>Search</label>
            <Input
              placeholder="Search"
              value={filters.batchCode}
              onChange={(e) => {
                const val = e.target.value;
                setFilters(prev => ({ ...prev, batchCode: val, page: 1 }));
                updateFilters({ batchCode: val, page: 1 });
              }}
            />
          </Col>
          <Col xs={24} md={12} lg={6}>
            <Space style={{ width: '100%', marginTop: '25px' }}>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={() => getTransactionData()}
              >
                Search
              </Button>
            </Space>
          </Col>

        </Row>
      </Card>
      <Table
        columns={dataCol}
        dataSource={data}
        pagination={false}
        footer={() => {
          const startRecord = (filters.page - 1) * limit + 1;
          const endRecord = Math.min(filters.page * limit, data?.length ? totalCount : 0);
          return `Showing ${startRecord}-${endRecord} of ${data?.length ? totalCount : "0"} Records`;
        }}
        style={{ marginTop: "10px" }}
        scroll={{ x: "max-content" }}
        rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
      />
      <div style={{ float: "right", margin: "10px" }}>
        <Pagination
          page={filters.page}
          count={totalPages}
          variant="outlined"
          color="primary"
          onChange={handleChange}
        />
      </div>
    </DataSheet>
  )
}

export default TransactionsCreditNoteList
